import { CompilerConfig } from '@angular/compiler';
import { Inject, Injectable } from '@angular/core';
import { CoreConfig } from './core-config.model';

@Injectable()
export class ConfigService {

    public config: CoreConfig = {
        appBasePath: 'http://localhost:4200',
        apiBasePath: 'http://localhost:5000',
        siteInfoApiBaseUrl: 'http://localhost:5002'
    };

    constructor(
        @Inject('HOSTNAME') private hostname: string
    ) {

        console.log('## Host ##', hostname);

        // Dev
        if (this.hostname.indexOf('devuserportal.mcd.se') > -1) {
            this.config = {
                appBasePath: 'https://devuserportal.mcd.se',
                apiBasePath: 'https://devauth.siteinfo.se',
                siteInfoApiBaseUrl: 'https://devapi.siteinfo.se'
            };
        }

        // Test
        if (this.hostname.indexOf('testuseradmin.mcd.se') > -1) {
            this.config = {
                appBasePath: 'https://testuseradmin.mcd.se',
                apiBasePath: 'https://testauth.siteinfo.se',
                siteInfoApiBaseUrl: 'https://testapi.siteinfo.se'
            };
        }

        // Prod
        if (this.hostname === 'useradmin.mcd.se') {
            this.config = {
                appBasePath: 'https://useradmin.mcd.se',
                apiBasePath: 'https://auth.siteinfo.se',
                siteInfoApiBaseUrl: 'https://api.siteinfo.se'
            };
        }

    }

}